import ShowerCommon from "./showerCommon";
import {createParentPositions, LOOK_ROOM_TYPES, ShowerHeadTypes} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getCurrentRoomType} from "../../../../appLayout";

export default class ValveTrim extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'valve_trim';
    this.partName = 'Valve Trim';
    this.translateId = "visualizer.bathroom.shower.valve_trim";
    this.canBeDisabled = true;
    this.conflictingPositions = ["shower_seats"];
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    // this.setArmHeadType(); // valve trims now working with shower fixture, and replacement tub as well
    const valveTrimParent = this.getParent();
    const showerParent = valveTrimParent.getParent();
    if (!valveTrimParent.getRenderValveType()) {
      if (!showerParent.showerTubComboIsActive()) {
        if (showerParent.showerHead?.activeFeature && showerParent.showerHead.disabled) {
          showerParent.showerHead.disabled = false;
          showerParent.showerHead.disabledClick();
        }
      }
    }
    super.handleClick();
  }

  // single bottom for Replacement Tub Fixture

  getRenderValveType() {
    let render = "";
    const showerParent = this.getParent();
    if (showerParent.handShowerKit?.activeFeature && !showerParent.handShowerKit.disabled
      && !showerParent.handShowerKit.hideLayerCondition()) {
      render = "Single";
    }
    switch (showerParent.shower_head_type) {
      case ShowerHeadTypes.shower_arm: {
        if (showerParent.showerHead?.activeFeature && !showerParent.showerHead.disabled) {
          render = render === "Single" ? "Dual" : "Single";
        }
        break;
      }
      case ShowerHeadTypes.shower_fixture: {
        const comboParent = showerParent.layout.parts[ShowerTubCombo.id];
        if (showerParent.showerFixture?.activeFeature && !showerParent.showerFixture.disabled
          || (showerParent.showerTubComboIsActive() && comboParent?.replacementTubFixture?.activeFeature
            && !comboParent.replacementTubFixture.disabled)) {
          render = render === "Single" ? "Dual" : "Single";
        }
        break;
      }
      default:
        break;
    }
    return render
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      const showerParent = this.getParent();
      const comboParent = showerParent.layout.parts[ShowerTubCombo.id];
      const valveType = this.getRenderValveType();
      if (valveType) {
        conditions.push({
          propName: "ValveType",
          propValue: valveType
        });
      }
      const isBottomPosition = (showerParent.showerTubComboIsActive() && comboParent?.replacementTubFixture?.activeFeature
        && !comboParent.replacementTubFixture.disabled);
      conditions.push({
        propName: "Placement",
        propValue: isBottomPosition ? "Bottom" : "Top"
      });
    }
    return conditions
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return !this.getRenderValveType();
    }
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm
  }
}
